import { render, staticRenderFns } from "./rs.vue?vue&type=template&id=21698f4f&scoped=true"
import script from "./rs.vue?vue&type=script&lang=js"
export * from "./rs.vue?vue&type=script&lang=js"
import style0 from "./rs.vue?vue&type=style&index=0&id=21698f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21698f4f",
  null
  
)

export default component.exports